import styled from 'styled-components'

export const Input = styled.input`
	box-sizing: border-box;
	padding: 10px 12px;
	border: 1px solid ${({ theme }) => theme.colors.grey};
	box-shadow: -2px 4px 10px rgba(115, 124, 142, 0.09);
	border-radius: ${({ isTextarea }) => (isTextarea ? '15px' : '25px')};
	height: ${({isTextarea}) => (isTextarea ? '400px' : null) };
	font-size: ${({ theme }) => theme.fontSize.l};
	resize: none;

	&:focus {
		outline: none;
		box-shadow: -2px 4px 10px rgba(115, 124, 142, 0.3);
	}
`
